import { render, staticRenderFns } from "./TabComponent.vue?vue&type=template&id=02a505a4&scoped=true"
import script from "./TabComponent.vue?vue&type=script&lang=js"
export * from "./TabComponent.vue?vue&type=script&lang=js"
import style0 from "./TabComponent.vue?vue&type=style&index=0&id=02a505a4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a505a4",
  null
  
)

export default component.exports